import React from "react";
export default function Tooltip(_a) {
    var tooltip = _a.tooltip, children = _a.children;
    return React.createElement("span", { title: tooltip }, children);
}
